module.exports = __webpack_public_path__ + "assets/img/partner3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/partner3.png
// module id = 1968
// module chunks = 0